/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { later, cancel } from '@ember/runloop';
import { EmberRunTimer } from '@ember/runloop/types';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import config from 'cio/config/environment';
import isDestroyed from 'cio/utils/is-destroyed';

interface SaveStatusArgs {
  timestamp: number;
  isSaving: boolean;
  detailedTimestampPrefix: string;
  detailedTimestampSuffix: string;
  metadata?: Record<string, string>;
}

// Disable timers in testing, otherwise the runloop will be stuck forever
const TIMER_DISABLED = config.isTest;

export default class SaveStatus extends Component<SaveStatusArgs> {
  @tracked lastUpdatedTimestamp!: number;
  @tracked timer: EmberRunTimer | null = null;

  get isSaving() {
    return this.args.isSaving || false;
  }

  @action
  updateLastUpdatedTimestamp() {
    if (isDestroyed(this)) {
      return;
    }

    this.lastUpdatedTimestamp = this.args.timestamp;
    this.scheduleTimer();
  }

  get detailedTimestampPrefix() {
    return this.args.detailedTimestampPrefix ?? '';
  }

  get detailedTimestampSuffix() {
    return `${this.args.detailedTimestampSuffix ?? ''}${this.metadataHtml}`;
  }

  @action
  scheduleTimer() {
    if (isDestroyed(this) || TIMER_DISABLED) {
      return;
    }

    let timer = later(this, this.updateLastUpdatedTimestamp, config.APP.longDelay);

    this.timer = timer;
  }

  get metadataHtml() {
    if (this.args.metadata == null || Object.keys(this.args.metadata).length === 0) {
      return '';
    }

    let html = '<br />'; // This comes right after an inline content, thus <br />
    for (let [key, value] of Object.entries(this.args.metadata)) {
      html += `<br /> <strong>${key}</strong>: ${value}`;
    }

    return html;
  }

  @action
  finalFormatter(timestampAsMoment: moment.Moment) {
    return timestampAsMoment.fromNow(false);
  }

  willDestroy() {
    super.willDestroy();

    if (this.timer) {
      cancel(this.timer);
    }
  }
}
